import type { UseQueryResult } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { useGetUserInformation } from "../api/get-user-information.api";
import type { UserInformation, UserVerificationStatus } from "../types";

type UseStatusResult = Pick<
  UseQueryResult<UserInformation, AxiosError>,
  "data" | "error" | "isPending" | "isError" | "isFetching" | "isSuccess" | "refetch"
> & {
  status: UserVerificationStatus;
  userData: UserInformation | undefined;
};

export const useStatus = (): UseStatusResult => {
  const query = useGetUserInformation();
  const { data, isPending, isError } = query;

  let status: UserVerificationStatus = "loading";
  if (!isPending && !isError && data) {
    status = data.verified ? "verified" : "notVerified";
  }

  return {
    data: query.data,
    error: query.error,
    isPending: query.isPending,
    isError: query.isError,
    isFetching: query.isFetching,
    isSuccess: query.isSuccess,
    refetch: query.refetch,
    status,
    userData: data,
  };
};
